import React from "react";
import BannerSlide from "../Slider/banner_slide";
const HeroSection = () => {
  return (
    <div className="flex justify-center items-center  rounded-xl ">
      {/* <img
        src={banner}
        className="md:w-11/12  object-contain md:object-cover rounded-xl"
        alt=""
      /> */}
      <BannerSlide />
    </div>
  );
};

export default HeroSection;
